























import Vue from 'vue'
import { TextFormField } from '@/model/registration'
import { PropType } from 'vue/types/umd'

export default Vue.extend({
  name: 'TextInput',
  props: {
    value: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    field: {
      type: Object as PropType<TextFormField>,
      required: true
    }
  },
  computed: {
    inputId (): string {
      return `textinput-${this.fieldName}`
    },
    inputType (): string {
      return this.field.textType ?? this.field.type
    },
    maxLength (): number {
      return this.field.maxLength ?? 100
    }
  },
  methods: {
    onInput (e: InputEvent) {
      this.$emit('input', { value: (e.target as HTMLInputElement).value })
    }
  }
})
